<template>
  <!-- 默认布局展开：宽 Logo（对齐 EB layout !== columns && !isCollapse） -->
  <div v-if="showFullLogo" class="layout-logo" @click="goHome">
    <img v-if="maxLogo" class="layout-logo-medium-img" :src="maxLogo" alt="logo" />
    <span v-else class="layout-logo-text-full">商户</span>
  </div>
  <!-- 分栏窄栏 / 侧栏收起：小 Logo -->
  <div v-else class="layout-logo-size" @click="goHome">
    <img v-if="minLogo" class="layout-logo-size-img" :src="minLogo" alt="logo" />
    <span v-else class="layout-logo-text">商户</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import Cookies from 'js-cookie';
import useCrmebThemeConfigStore from '@/store/modules/themeConfig';
import { useCrmebShell } from '@/config/crmeb-shell';
import defaultSettings from '@/setting';
import { resolveAdminHomePath } from '@/config/admin-route';
import useCrmebMenuStore from '@/store/modules/menu';

const router = useRouter();
const themeStore = useCrmebThemeConfigStore();

interface MerInfoCookie {
  menuLogo?: string;
  menuSlogo?: string;
}

function readMerInfo(): MerInfoCookie | null {
  try {
    const raw = Cookies.get('MerInfo');
    if (!raw) return null;
    return JSON.parse(raw) as MerInfoCookie;
  } catch {
    return null;
  }
}

const merInfo = computed(() => readMerInfo());
// API / Cookie 驼峰（对齐 Nest loginConfig：menuLogo / menuSlogo）
const maxLogo = computed(() => merInfo.value?.menuLogo || '');
const minLogo = computed(() => merInfo.value?.menuSlogo || merInfo.value?.menuLogo || '');

/**
 * 对齐 EB logo setShowLogo：
 * - 分栏/经典/横向顶栏：小 Logo
 * - 移动端（<1000）：抽屉内始终宽 Logo
 * - 默认桌面：未折叠用宽 Logo
 */
const showFullLogo = computed(() => {
  const { layout, isCollapse } = themeStore.themeConfig;
  if (layout === 'columns') return false;
  if (layout === 'classic' || layout === 'transverse') return false;
  if (typeof document !== 'undefined' && document.body.clientWidth < 1000) {
    return true;
  }
  return !isCollapse;
});

function goHome() {
  if (useCrmebShell) {
    const crmebMenu = useCrmebMenuStore();
    router.push(resolveAdminHomePath(crmebMenu.menuTree));
    return;
  }
  router.push(`${defaultSettings.roterPre}/dashboard`);
}
</script>

<style scoped lang="scss">
.layout-logo {
  width: 180px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
  &-medium-img {
    max-width: 160px;
    max-height: 50px;
    object-fit: contain;
  }
}
.layout-logo-text-full {
  color: var(--prev-bg-menuBarColor, #fff);
  font-size: 16px;
  font-weight: 600;
}
.layout-logo-size {
  display: flex;
  cursor: pointer;
  margin: auto;
  height: 50px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  &-img {
    width: 50px;
    height: auto;
    margin: auto;
  }
}
.layout-logo-text {
  color: var(--prev-bg-columnsMenuBarColor, #e6e6e6);
  font-size: 14px;
}
</style>
